'use strict';

exports.__esModule = true;
exports.DefaultValue = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ = require('../../../../../..');

var _2 = _interopRequireDefault(_);

var _3 = require('..');

var _4 = _interopRequireDefault(_3);

var _ObjectView = require('../../../../ObjectConnector/ObjectView');

var _ObjectView2 = _interopRequireDefault(_ObjectView);

var _ListView = require('../../../ListView');

var _ListView2 = _interopRequireDefault(_ListView);

var _CurrentUser = require('../../../../../CurrentUser');

var _CurrentUser2 = _interopRequireDefault(_CurrentUser);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DefaultValue = exports.DefaultValue = (_temp = _class = function (_EditorComponent) {
  _inherits(DefaultValue, _EditorComponent);

  function DefaultValue() {
    _classCallCheck(this, DefaultValue);

    return _possibleConstructorReturn(this, _EditorComponent.apply(this, arguments));
  }

  DefaultValue.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelButton
    }, 'DefaultValue'));
  };

  DefaultValue.prototype.getRootElement = function getRootElement() {
    return _EditorComponent.prototype.getRootElement.call(this);
  };

  DefaultValue.prototype.canBeParent = function canBeParent(parent) {
    return parent instanceof _4.default || parent instanceof _ObjectView2.default || parent instanceof _ListView2.default || parent instanceof _CurrentUser2.default;
  };

  DefaultValue.prototype.canBeChild = function canBeChild(child) {
    return _EditorComponent.prototype.canBeChild.call(this, child);
  };

  DefaultValue.prototype.renderChildren = function renderChildren() {
    _objectDestructuringEmpty(this.context);

    var _getEditorContext2 = this.getEditorContext();

    _objectDestructuringEmpty(_getEditorContext2);

    var _getComponentProps = this.getComponentProps(this),
        other = _objectWithoutProperties(_getComponentProps, []);

    return _EditorComponent.prototype.renderChildren.call(this);
  };

  return DefaultValue;
}(_2.default), _class.Name = 'DefaultValue', _class.defaultProps = _extends({}, _2.default.defaultProps, {
  hide_wrapper_in_default_mode: true
}), _temp);
exports.default = DefaultValue;